<template>
  <div class="audio">
    <audio 
      ref="audio"
      :src="url" 
      @loadedmetadata="onLoadedmetadata"
    ></audio>
  </div>
</template>

<script>
  export default {
    props: {
      url: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        audio: {
          playing: false,
          currentTime: 0,
          isOk: false,
        }
      }
    },
    methods: {
      onLoadedmetadata(){
        this.isOk = true
      },
      onPlay() {
        this.isOk = false
        this.$refs.audio.play()
        this.audio.playing = true
      },
      onPause(){
        this.$refs.audio.pause()
        this.audio.playing = false
      }
    }
  }
</script>

<style lang="less" scoped>

</style>